/**
 * Blaze Theme Sound Configuration
 *
 * Fire-themed sounds for the Inferno/Blaze 3D board theme
 * Includes sounds for movement, hard drop, line clear, and tetris finisher
 */

import fireMovementSound from '../../../../assets/sounds/themes/blaze/fire-movement-new.wav';
import fireHardDropSound from '../../../../assets/sounds/themes/blaze/fire-harddrop.wav';
import fireLineClearSound from '../../../../assets/sounds/themes/blaze/fire-lineclear-new.wav';
import fireFinisherSound from '../../../../assets/sounds/themes/blaze/fire-finisher.wav';
import fireTetrisSound from '../../../../assets/sounds/themes/blaze/fire-tetris.wav';
import rotateBlockSoundPath from '../../../../assets/sounds/rotateBlockTrimmed.wav';

export const BLAZE_SOUND_CONFIG = {
  name: 'Blaze',
  description: 'Fire-themed sounds for Inferno board',

  // Theme sound definitions
  sounds: {
    // Zippo fire close for piece movements (left/right/down/rotate)
    movement: {
      src: fireMovementSound,
      volume: 0.4,    // Moderate volume for frequent sounds
      rate: 1.0
    },

    // Fire whoosh/punch for hard drop
    hardDrop: {
      src: fireHardDropSound,
      volume: 0.6,
      rate: 1.0
    },

    // Ghost fire swoosh for single line clears (1 line)
    lineClear: {
      src: fireLineClearSound,
      volume: 0.5,
      rate: 1.0
    },

    // Intense fire beam for multi-line clears (2+ lines)
    tetris: {
      src: fireFinisherSound,
      volume: 0.6,
      rate: 1.0
    },

    // Failed rotation sound
    rotateBlock: {
      src: rotateBlockSoundPath,
      volume: 0.5,
      rate: 1.0
    }
  },

  /**
   * Mappings from game sound keys to theme sound keys
   *
   * Game sound keys (from utilities.js):
   * - fall: Piece movement (left/right/down/rotate success)
   * - rotateBlockSound: Failed rotation attempt
   * - whipSound: Hard drop impact
   * - blasterSound: Line clear laser effect
   * - deliciousSound: Tetris (4-line clear) celebration
   *
   * Set to null to use default sound (no theme override)
   */
  mappings: {
    fall: 'movement',              // Movement sounds → zippo fire close
    rotateBlockSound: 'rotateBlock', // Failed rotation → rotateBlock.wav
    whipSound: 'hardDrop',         // Hard drop → fire whoosh
    blasterSound: 'lineClear',     // Single line clear → ghost fire swoosh
    deliciousSound: 'tetris'       // Multi-line finisher (2+) → intense fire beam
  }
};

export default BLAZE_SOUND_CONFIG;
